import React from "react";

interface QuadrilateralWithRoundCornersProps {
  a?: string | number;
  b?: string | number;
  c?: string | number;
  foldType?: string;
  foldDirection?: number;
  arrowColor?: string;
  textColor?: string;
}

const QuadrilateralWithRoundCorners: React.FC<QuadrilateralWithRoundCornersProps> = ({
  a = "",
  b = "",
  c = "",
  foldType = "",
  foldDirection = 1,
  arrowColor = "#1E8F31",
  textColor = "#000"
}) => {
  return (
    <svg
      width="236"
      height="210"
      viewBox="-30 0 275 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Square/Rectangle round corners */}
      <rect
        x="42"
        y="42"
        width="142"
        height="142"
        rx="11"
        stroke="#1E8F31"
        strokeWidth="3"
      />

      {/* Arrows */}
      <path
        d="M21 38L17.5359 44L24.4641 44L21 38ZM21 188L24.4641 182L17.5359 182L21 188ZM20.4 43.4L20.4 182.6L21.6 182.6L21.6 43.4L20.4 43.4Z"
        fill={arrowColor}
      />
      <path
        d="M38 19L44 22.4641V15.5359L38 19ZM188 19L182 15.5359V22.4641L188 19ZM43.4 19.6H182.6V18.4H43.4V19.6Z"
        fill={arrowColor}
      />
      <line x1="166" y1="187.4" x2="214" y2="187.4" stroke="#565656" strokeWidth="1.2" />
      <line x1="188" y1="166.4" x2="214" y2="166.4" stroke="#565656" strokeWidth="1.2" />
      <path
        d="M195 167L191.536 173L198.464 173L195 167ZM195 187L198.464 181L191.536 181L195 187ZM194.4 172.4L194.4 181.6L195.6 181.6L195.6 172.4L194.4 172.4Z"
        fill={arrowColor}
      />

      {/* Letters */}
      <text
        xmlSpace="preserve"
        textAnchor="end"
        fontFamily="Roboto"
        fontSize="12"
        y="109.12811"
        x="18.334"
        fill={textColor}
      >
        A: {a}
      </text>
      <text
        xmlSpace="preserve"
        fontFamily="Roboto"
        fontSize="12"
        y="15.28255"
        x="102.89745"
        fill={textColor}
      >
        B: {b}
      </text>
      <text
        xmlSpace="preserve"
        fontFamily="Roboto"
        fontSize="12"
        y="180.92253"
        x="198.79428"
        fill={textColor}
      >
        C: {c}
      </text>

      {/* Bi Fold V */}
      {foldType === "Bi-Fold" && foldDirection === 2 && (
        <line
          x1="113.6"
          y1="46"
          x2="113.6"
          y2="180"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold V */}
      {foldType === "Tri-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="89.6"
            y1="46"
            x2="89.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="137.6"
            y1="46"
            x2="137.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold V */}
      {foldType === "Quad-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="113.6"
            y1="46"
            x2="113.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="76.6"
            y1="46"
            x2="76.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="148.6"
            y1="46"
            x2="148.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Five Fold V */}
      {foldType === "Five-Fold" && foldDirection === 2 && (
        <>
          <line x1="73.4" y1="48" x2="73.4" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="100.2" y1="48" x2="100.2" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="127" y1="48" x2="127" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="153.8" y1="48" x2="153.8" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold V */}
      {foldType === "Six-Fold" && foldDirection === 2 && (
        <>
          <line x1="70.933" y1="48" x2="70.933" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="93.263" y1="48" x2="93.263" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="115.593" y1="48" x2="115.593" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="137.923" y1="48" x2="137.923" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="160.253" y1="48" x2="160.253" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Bi Fold H */}
      {foldType === "Bi-Fold" && foldDirection === 1 && (
        <line
          x1="46"
          y1="112.4"
          x2="180"
          y2="112.4"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold H */}
      {foldType === "Tri-Fold" && foldDirection === 1 && (
        <>
          <line x1="46" y1="89.4" x2="180" y2="89.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="136.4" x2="180" y2="136.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Quad Fold H */}
      {foldType === "Quad-Fold" && foldDirection === 1 && (
        <>
          <line x1="46" y1="112.4" x2="180" y2="112.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="76.4" x2="180" y2="76.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="149.4" x2="180" y2="149.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Five Fold H */}
      {foldType === "Five-Fold" && foldDirection === 1 && (
        <>
          <line x1="46" y1="74.2" x2="190" y2="74.2" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="101" x2="190" y2="101" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="127.8" x2="190" y2="127.8" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="154.6" x2="190" y2="154.6" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold H */}
      {foldType === "Six-Fold" && foldDirection === 1 && (
        <>
          <line x1="46" y1="69.7333" x2="190" y2="69.7333" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="92.063" x2="190" y2="92.063" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="114.393" x2="190" y2="114.393" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="136.723" x2="190" y2="136.723" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="46" y1="159.053" x2="190" y2="159.053" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}
    </svg>
  );
};

export default QuadrilateralWithRoundCorners;
